(function () {
  if (window.__auctionFreeShippingBadgeInit) return;
  window.__auctionFreeShippingBadgeInit = true;

  function checkFreeShippingBadge(node) {
    var wrapper = node.closest('.product-card-wrapper');
    if (!wrapper) return;

    var badge = wrapper.querySelector('[data-badge-element="free-shipping"]');
    if (!badge) return;

    var productId = badge.getAttribute('data-product-id');
    var contexts = window.Tipo && window.Tipo.Auction && window.Tipo.Auction.auctionContexts;
    if (!contexts) return;

    var ctx = contexts[productId];
    if (!ctx) return;

    var amount = ctx.summary && ctx.summary.amount != null ? ctx.summary.amount : null;

    if (amount !== null && amount < 99) {
      badge.style.display = 'none';
    }
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('tpa-collection-widget')) {
          checkFreeShippingBadge(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.tpa-collection-widget').forEach(function (widget) {
            checkFreeShippingBadge(widget);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
